export default {
	setLoading (state, value) {
		state.loading = value;
	}
};
